import { Reservation } from "../types/types";

// const API_URL = "http://localhost:3331/api";
const API_URL = "https://api.nameren-rai.com/api";

// Използваме localStorage вместо in-memory storage
export const initDatabase = () => {
  // Не е нужна инициализация за REST API
};

export const createReservation = async (
  reservation: Pick<
    Reservation,
    "startDate" | "endDate" | "firstName" | "lastName" | "phone" | "email"
  >
): Promise<number> => {
  try {
    //console.log("Sending reservation data:", reservation);
    const response = await fetch(`${API_URL}/reservations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(reservation),
    });

    const data = await response.json();
    //console.log("Server response:", data);

    if (!response.ok) {
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }

    return data.id;
  } catch (error) {
    console.error("Error creating reservation:", error);
    throw error;
  }
};

export const getReservations = async (): Promise<Reservation[]> => {
  try {
    //console.log("Fetching reservations...");
    const response = await fetch(`${API_URL}/reservations`);
    //console.log("Response status:", response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    //console.log("Received data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching reservations:", error);
    throw new Error("Грешка при извличане на резервациите");
  }
};
